export default "__VITE_ASSET__Djnipek1__"